import { ReactNode, useContext } from 'react';
import { css as emotionCSS } from '@emotion/react';
import { Typography } from '@mildang/mui';
import { generateVariantValues, DocumentContext } from './DocumentContext';

const rootStyle = emotionCSS`
  margin-top: 50px;
`;

const SubTitle = ({ children }: { children: ReactNode }) => {
  const { variant } = useContext(DocumentContext);

  return (
    <Typography
      css={rootStyle}
      variant={generateVariantValues({
        screen: 'h4' as const,
        dialog: 'h6' as const,
      })(variant)}
    >
      {children}
    </Typography>
  );
};

export default SubTitle;
